import React, { useState } from 'react';
import { Tabs } from 'react-tabs';

function AccessibleTabs(props) {
    // the initial state of lastFocusedTab is also 0 so that on loading the screen, focus doesn't jump directly to the tab
    const [lastFocusedTab, setLastFocusedTab] = useState(0);

    /**
     * While it is hacky to be overriding the imported component, this is needed for accessibility purposes
     * to put focus on keyboard-selected tab. This can get called when any part of the tabs' state gets changed.
     * It will only shift focus to the tab when the tab is being selected via left and right arrows.
     * @param {Object} tabProps - the props for the react-tabs Tab component being rendered
     * @returns {{ focus: boolean }} - determines if the current tab being rendered should receive focus or not
     */
    Tabs.copyPropsToState = (tabProps) => {
        const shouldFocusTab = tabProps.selectedIndex !== lastFocusedTab;
        setLastFocusedTab(tabProps.selectedIndex);
        return { focus: shouldFocusTab }
    };
    
    return <Tabs {...props} />
}

export default AccessibleTabs;
